(() => {
  const initAccountTabs = () => {
    const tabsRoot = document.querySelector('[data-firera-account-tabs]');
    const panelsRoot = document.querySelector('[data-firera-account-panels]');
    if (!tabsRoot || !panelsRoot) return;

    const tabs = [...tabsRoot.querySelectorAll('[data-firera-account-tab]')];
    const panels = [...panelsRoot.querySelectorAll('[data-firera-account-panel]')];
    const heading = document.querySelector('[data-firera-account-heading]');
    const headings = {
      overview: 'HESABIM',
      profile: 'PROFİLİM',
      wishlist: 'İSTEK LİSTEM',
      addresses: 'ADRESLERİM',
      orders: 'SİPARİŞLERİM'
    };

    if (window.location.hash) {
      window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
    }

    const showPanel = (target) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.fireraAccountTab === target;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        panel.hidden = target !== 'overview' && panel.dataset.fireraAccountPanel !== target;
      });

      panelsRoot.classList.toggle('is-detail-view', target !== 'overview');

      if (heading) heading.textContent = headings[target] || headings.overview;

      panelsRoot.classList.remove('is-switching');
      void panelsRoot.offsetWidth;
      panelsRoot.classList.add('is-switching');
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => showPanel(tab.dataset.fireraAccountTab || 'overview'));
    });

    showPanel('overview');
  };

  let wishlistSignature = '';
  let notifyMeBootstrapped = false;

  const renderWishlist = () => {
    const root = document.querySelector('[data-firera-account-wishlist]');
    if (!root) return;

    const list = root.querySelector('[data-firera-account-wishlist-list]');
    const empty = root.querySelector('[data-firera-account-wishlist-empty]');
    const count = root.querySelector('[data-firera-account-wishlist-count]');
    if (!list || !empty || !count) return;

    const sourceCards = [...document.querySelectorAll('.nm-wishlist-drawer .nm-wishlist-item-card')];
    const drawer = document.querySelector('.nm-wishlist-drawer');
    const launcher = document.querySelector('.nm-wishlist-open-list-button');

    if (drawer && launcher && !notifyMeBootstrapped) {
      notifyMeBootstrapped = true;
      count.textContent = 'Yükleniyor…';
      launcher.click();
      window.setTimeout(() => {
        wishlistSignature = '';
        renderWishlist();
      }, 800);
      return;
    }

    const signature = `${drawer ? 'loaded' : 'pending'}:` + sourceCards.map((card) => {
      const link = card.querySelector('.nm-wishlist-item-name');
      const price = card.querySelector('.nm-wishlist-item-price');
      return `${link?.getAttribute('href') || ''}|${price?.textContent || ''}`;
    }).join('::');

    if (signature === wishlistSignature && list.childElementCount === sourceCards.length) return;
    wishlistSignature = signature;

    count.textContent = drawer ? `${sourceCards.length} ürün` : 'Yükleniyor…';
    list.replaceChildren();
    empty.hidden = !drawer || sourceCards.length > 0;

    sourceCards.forEach((sourceCard) => {
      const sourceLink = sourceCard.querySelector('.nm-wishlist-item-name');
      const sourceImage = sourceCard.querySelector('.nm-wishlist-item-image');
      const sourcePrice = sourceCard.querySelector('.nm-wishlist-item-price');
      const sourceAddButton = sourceCard.querySelector('.nm-wishlist-item-add-to-cart-button');
      const sourceRemoveButton = sourceCard.querySelector('.nm-wishlist-item-remove-button');

      const item = document.createElement('article');
      item.className = 'firera-account-wishlist__item';

      const imageLink = document.createElement('a');
      imageLink.href = sourceLink?.href || '#';

      const image = document.createElement('img');
      image.className = 'firera-account-wishlist__image';
      image.src = (sourceImage?.src || '').replace(/([?&])width=72(&|$)/, '$1width=600$2');
      image.alt = sourceImage?.alt || sourceLink?.textContent?.trim() || '';
      image.loading = 'lazy';
      imageLink.append(image);

      const content = document.createElement('div');
      content.className = 'firera-account-wishlist__content';
      const title = document.createElement('p');
      title.className = 'firera-account-wishlist__title';
      title.textContent = sourceLink?.textContent?.trim() || 'Ürün';
      const price = document.createElement('p');
      price.className = 'firera-account-wishlist__price';
      price.textContent = sourcePrice?.textContent?.trim() || '';

      const actions = document.createElement('div');
      actions.className = 'firera-account-wishlist__actions';

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'firera-account-wishlist__action';
      remove.textContent = 'KALDIR';
      remove.addEventListener('click', () => sourceRemoveButton?.click());

      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'firera-account-wishlist__action firera-account-wishlist__action--primary';
      add.textContent = 'SEPETE EKLE';
      add.addEventListener('click', () => sourceAddButton?.click());

      actions.append(remove, add);
      content.append(title, price, actions);
      item.append(imageLink, content);
      list.append(item);
    });
  };

  const observeNotifyMeWishlist = () => {
    let frame = 0;
    const observer = new MutationObserver(() => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(renderWishlist);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAccountTabs();
      renderWishlist();
      observeNotifyMeWishlist();
    });
  } else {
    initAccountTabs();
    renderWishlist();
    observeNotifyMeWishlist();
  }

  document.addEventListener('wishlistUpdated', renderWishlist);
})();
